import CircularProgress from '@mui/material/CircularProgress'
import { Container, Card } from 'components'
import colors from 'theme/colors'

interface ILoaderProps {
  type?: 'container' | 'default'
  loading?: boolean
}

const Loader: React.FC<ILoaderProps> = (props) => {
  const { type = 'container', loading } = props
  const CircularLoader = () => {
    return (
      <Container
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '90vh',
        }}
      >
        <CircularProgress
          size={70}
          sx={{
            color: colors.primary,
          }}
        />
      </Container>
    )
  }

  if (!loading) {
    return <></>
  }

  return type === 'container' ? (
    <Card
      sxContainer={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        zIndex: 2,
      }}
    >
      <CircularLoader />
    </Card>
  ) : (
    <CircularLoader />
  )
}

export default Loader
